$(() => {
  $(".custom-slider").slide({
    type: "loop",
    perPage: 2,
    perMove: 2,
    mediaQuery: "max",
    pagination: true,
    breakpoints: {
      992: {
        perPage: 1,
        perMove: 1,
      },
    },
  });
});
